// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Y7--","error":"Textarea_error__3h7Xv","readonly":"Textarea_readonly__14Nak","disabled":"Textarea_disabled__3f5gY"};